import { render, staticRenderFns } from "./MicrosoftAdminOauthSettings.vue?vue&type=template&id=17ff152c&scoped=true"
import script from "./MicrosoftAdminOauthSettings.vue?vue&type=script&lang=js"
export * from "./MicrosoftAdminOauthSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff152c",
  null
  
)

export default component.exports